'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SignUpForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _forms = require('common/components/forms');

var _reactReduxForm = require('react-redux-form');

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _qs = require('qs');

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _reactRedux = require('react-redux');

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _googleLoginOrSignup = require('./google-login-or-signup');

var _googleLoginOrSignup2 = _interopRequireDefault(_googleLoginOrSignup);

var _orDivider = require('common/components/or-divider');

var _orDivider2 = _interopRequireDefault(_orDivider);

require('./sign-up-form.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//import GoogleSigninButton   from './google-signin-button';


var FORM_NAME = 'signUp';

var tosLink = _hfReactHelper2['default'].urlHelper('info/tos', _hfReactHelper2['default'].HfSites.SITE_CODE_HS, 'www');
var privacyPolicyLink = _hfReactHelper2['default'].urlHelper('info/privacyPolicy', _hfReactHelper2['default'].HfSites.SITE_CODE_HS, 'www');

var SignUpForm = exports.SignUpForm = function (_React$Component) {
    _inherits(SignUpForm, _React$Component);

    function SignUpForm(props) {
        _classCallCheck(this, SignUpForm);

        var _this = _possibleConstructorReturn(this, (SignUpForm.__proto__ || Object.getPrototypeOf(SignUpForm)).call(this, props));

        _this.handleGeneralError = _this.handleGeneralError.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleResponse = _this.handleResponse.bind(_this);
        return _this;
    }

    /**
     * Handles any generic/fallback errors we want to handle
     */


    _createClass(SignUpForm, [{
        key: 'handleGeneralError',
        value: function handleGeneralError(error) {
            this.props.dispatch(_reactReduxForm.actions.setSubmitFailed(FORM_NAME));
        }
    }, {
        key: 'handleResponse',
        value: function handleResponse(err, response) {
            // Error here means some kind of network error (4xx or 5xx)
            if (err) {
                return this.handleGeneralError(err);
            }

            try {
                var resp = response.body;

                // Create notification if backend provided one
                if (resp.notification) {
                    hellofaxJS.createNotification({
                        'text': resp.notification.message,
                        'class_name': resp.notification.type
                    });
                }

                // Handle success and failure
                if (resp.success === true) {
                    this.props.dispatch(_reactReduxForm.actions.setSubmitted(FORM_NAME));

                    // Redirect to redirect_url
                    if (resp.redirect_url) {
                        window.location = resp.redirect_url;
                    }
                } else {
                    this.props.dispatch(_reactReduxForm.actions.setSubmitFailed(FORM_NAME));

                    var hasErrorMsg = !!(resp.error && resp.error.message);
                    if (hasErrorMsg && !resp.notification_message) {
                        // Display error message
                        this.props.dispatch(_reactReduxForm.actions.setErrors(FORM_NAME, {
                            server: resp.error.message
                        }));
                    }
                }

                if (response.error) {
                    this.props.dispatch(_reactReduxForm.actions.setErrors(FORM_NAME, {
                        server: resp.error.message
                    }));
                }
            } catch (e) {
                return this.handleGeneralError(err);
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(values) {
            var _this2 = this;

            // Prepare the POST
            var url = _hfReactHelper2['default'].urlHelper('account/signUp', _hfReactHelper2['default'].HfSites.SITE_CODE_HS);
            var data = (0, _qs.stringify)({
                signup: {
                    email_address: values.email,
                    is_opted_in_marketing_emails: values.marketingOptIn,
                    redirect_url: values.redirectUrl,
                    pending_tsm_group_guid: values.pendingTsmGroupGuid,
                    _csrf_token: values.csrfToken
                },
                force_delay_analytics_js: true,
                async: 1
            });

            // POST to the server
            return _superagent2['default'].post(url).type('form').send(data).on('request', function () {
                _this2.props.dispatch(_reactReduxForm.actions.setPending(FORM_NAME));
            }).end(this.handleResponse);
        }
    }, {
        key: 'render',
        value: function render() {
            var logInUrl = _hfReactHelper2['default'].urlHelper('account/logIn', _hfReactHelper2['default'].HfSites.SITE_CODE_HS);

            // Old-style Google Signin Button (TODO: Replace with new GoogleSigninButton component)
            var googleLoginImage = _react2['default'].createElement(
                'div',
                { className: 'm-create-account--modal-google-login-border' },
                _react2['default'].createElement('div', { className: 'm-create-account--modal-google-login-or-image' })
            );
            var googleOpenId = _react2['default'].createElement(
                'div',
                { className: 'm-create-account--modal-google-login text-center' },
                googleLoginImage,
                _react2['default'].createElement(
                    'div',
                    { className: 'm-create-account--modal-google-login-button' },
                    _react2['default'].createElement(_googleLoginOrSignup2['default'], {
                        openIdUrl: this.props.googleOpenIdUrl,
                        isOptedIn: this.props.isOptedIn,
                        isLogIn: false })
                )
            );

            return _react2['default'].createElement(
                'div',
                { className: 'm-sign-up-form' },
                _react2['default'].createElement(
                    _reactReduxForm.Form,
                    { model: FORM_NAME, onSubmit: this.handleSubmit },
                    _react2['default'].createElement(
                        'h2',
                        null,
                        'Let\'s get started'
                    ),
                    googleOpenId,
                    _react2['default'].createElement(_orDivider2['default'], null),
                    _react2['default'].createElement(
                        _forms.Field,
                        { label: 'Email Address' },
                        _react2['default'].createElement(_reactReduxForm.Control.input, {
                            type: 'email',
                            model: 'signUp.email',
                            validators: { isEmail: _hfReactHelper2['default'].isValidEmailAddress }
                        }),
                        _react2['default'].createElement(_reactReduxForm.Errors, {
                            model: 'signUp.email',
                            show: 'touched',
                            messages: {
                                isEmail: 'Please enter a valid email address'
                            },
                            className: 'm-field--error'
                        })
                    ),
                    _react2['default'].createElement(_button2['default'], {
                        buttonText: 'Create an account',
                        buttonColor: 'cerulean',
                        type: 'submit',
                        disabled: this.props.pending
                    }),
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-sign-up-form--marketing-opt-in' },
                        _react2['default'].createElement(
                            'label',
                            null,
                            _react2['default'].createElement(_reactReduxForm.Control.checkbox, { model: 'signUp.marketingOptIn' }),
                            ' Send me HelloSign updates'
                        )
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'l-margin-v-20' },
                        _react2['default'].createElement(_reactReduxForm.Errors, {
                            model: FORM_NAME,
                            show: true,
                            className: 'c-red'
                        })
                    ),
                    _react2['default'].createElement(
                        'p',
                        { className: 'l-margin-t-40 l-margin-b-20 m-sign-up-form--tos' },
                        'By signing up, I accept the ',
                        _react2['default'].createElement(
                            'a',
                            { href: tosLink },
                            'HelloSign TOS'
                        ),
                        ' & ',
                        _react2['default'].createElement(
                            'a',
                            { href: privacyPolicyLink },
                            'Privacy Policy'
                        ),
                        '.'
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-sign-up-form--sign-in-link' },
                        _react2['default'].createElement('hr', null),
                        _react2['default'].createElement(
                            'p',
                            null,
                            'Already have an account? ',
                            _react2['default'].createElement(
                                'a',
                                { href: logInUrl },
                                'Sign in \u203A'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return SignUpForm;
}(_react2['default'].Component);

SignUpForm.propTypes = {
    // Provided from Redux state by connect
    pending: _react2['default'].PropTypes.bool.isRequired,

    // Needed by the GoogleSigninButton component
    isOptedIn: _react2['default'].PropTypes.bool.isRequired,

    // Redux dispatcher object, provided from Redux by connect
    dispatch: _react2['default'].PropTypes.func.isRequired,

    // Needed by the GoogleLoginOrSignup component
    googleOpenIdUrl: _react2['default'].PropTypes.string.isRequired
};


function mapStateToProps(state) {
    var $form = state.forms.signUp.$form;


    return {
        pending: $form.pending,
        isOptedIn: state.signUp.marketingOptIn
    };
}

exports['default'] = (0, _reactRedux.connect)(mapStateToProps)(SignUpForm);


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/sign-up-form.jsx
 ** module id = 1002
 ** module chunks = 0
 **/